import { render, staticRenderFns } from "./RouteDescription.vue?vue&type=template&id=e6242d5c&scoped=true&"
import script from "./RouteDescription.vue?vue&type=script&lang=js&"
export * from "./RouteDescription.vue?vue&type=script&lang=js&"
import style0 from "./RouteDescription.vue?vue&type=style&index=0&id=e6242d5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6242d5c",
  null
  
)

export default component.exports